import React from 'react';
import {
  Button,
} from '../../../form/FormControls.jsx';
import { connect } from 'react-redux';
import { saveLinkIdxToAssignTransport, clearQuantity } from '../../../../store/links.store';
import vessel from '@/../style/vesselbtn.png';
import container from '@/../style/containerbtn.png';
import railcar from '@/../style/railcarbtn.png';
import truck from '@/../style/truckbtn.png';
import linkplus from '@/../style/linkplus.png';
import { push } from 'react-router-redux';
import store from '@/store/store';
import RoleConfigFilter from '../../../auth/RoleConfigFilter.jsx';


class ConnectTransportElement extends React.Component {
  constructor(props) {
    super(props);
    this.defineSelectedLink = this.defineSelectedLink.bind(this);
  }

  defineSelectedLink() {
    if (this.props.fromList && this.props.dealId && this.props.fromType) {
      store.dispatch(push(`/deals/${this.props.fromType}/${this.props.dealId}`));
    }
    setTimeout(() => this.props.saveLinkIdxToAssignTransport(), 0);
  }

  render() {
    let icon;
    switch (this.props.transportType) {
      case 'CONTAINER':
        icon = container;
        break;
      case 'TRUCK':
        icon = truck;
        break;
      case 'RAILCAR':
        icon = railcar;
        break;
      case 'BULK':
      default:
        icon = vessel;
        break;
    }
    return (
      <RoleConfigFilter
        permissions={['allDeals#2', 'myDeals#2']}
      >
        <Button
          id="addTransport"
          className={'add-link-btn'}
          bsStyle={!!this.props.buttonType ? this.props.buttonType : 'primary'}
          style={this.props.buttonStyle}
          onClick={this.defineSelectedLink}
        >
          {!!this.props.children
            ? ''
            : <span>
              <img
                src={icon}
                className={`add-link-btn-icon add-transport-btn-icon btn-transport-${
                  this.props.transportType}`}
                alt="Transport"
              />
              <img src={linkplus} className={'add-link-btn-plus'} alt="Add transport" />
            </span>}
        </Button>
      </RoleConfigFilter>
    );
  }
}

ConnectTransportElement.propTypes = {
  children: React.PropTypes.object,
  buttonType: React.PropTypes.string,
  buttonStyle: React.PropTypes.object,
  link: React.PropTypes.object,
  saveLinkIdxToAssignTransport: React.PropTypes.func,
  fromList: React.PropTypes.bool,
  fromType: React.PropTypes.string,
  dealId: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  productIdx: React.PropTypes.number,
  productId: React.PropTypes.number,
  linkIdx: React.PropTypes.number,
  transportType: React.PropTypes.string,
};

export default connect(
  () => ({}),
  (dispatch, props) => ({
    clearQuantity() {
      clearQuantity(dispatch);
    },
    saveLinkIdxToAssignTransport() {
      saveLinkIdxToAssignTransport(dispatch, props.productIdx, props.linkIdx,
        props.productId, props.fromList);
    } })
)(ConnectTransportElement);
